/**
 * Authoring aid for step 1 of the NDS Home Drainage Center wizard.
 * Add ?hotspotDebug=1 to the page and click anywhere on the illustration to read off
 * the Hotspot X / Hotspot Y percentages to paste into the widget designer.
 * Only runs when the query string asks for it, so it costs nothing in production.
 */
const IMAGE_SELECTOR = '.drainage-pins__image, .drainage-problems__illustration-img';

function init() {
	if (new URLSearchParams(window.location.search).get('hotspotDebug') !== '1') return;

	const readout = buildReadout();

	document.body.appendChild(readout);

	//the default template is rendered by Vue, so the image may not exist yet
	document.addEventListener('click', (event) => onClick(event, readout), true);
}

function onClick(event, readout) {
	const image = event.target.closest ? event.target.closest(IMAGE_SELECTOR) : null;

	if (!image) return;

	event.preventDefault();

	const box = image.getBoundingClientRect();
	const x = clamp(((event.clientX - box.left) / box.width) * 100);
	const y = clamp(((event.clientY - box.top) / box.height) * 100);

	placeMarker(image, x, y);
	showReadout(readout, x, y);
}

function placeMarker(image, x, y) {
	const stage = image.parentElement;

	if (!stage) return;

	//the pins stage is already positioned, the default illustration wrapper is too
	let marker = stage.querySelector('.drainage-hotspot-debug__marker');

	if (!marker) {
		marker = document.createElement('span');
		marker.className = 'drainage-hotspot-debug__marker';
		stage.appendChild(marker);
	}

	marker.style.left = x + '%';
	marker.style.top = y + '%';
}

function showReadout(readout, x, y) {
	const text = 'X: ' + x + '%   Y: ' + y + '%';

	readout.textContent = text;
	readout.hidden = false;

	copy(text);
}

function buildReadout() {
	const el = document.createElement('div');

	el.className = 'drainage-hotspot-debug__readout';
	el.hidden = true;

	return el;
}

function copy(text) {
	if (!navigator.clipboard || !navigator.clipboard.writeText) return;

	navigator.clipboard.writeText(text).catch(() => {});
}

function clamp(value) {
	return Math.round(Math.min(100, Math.max(0, value)) * 10) / 10;
}

export { init };
